module.exports = __webpack_public_path__ + "static/media/r445.653157d6.jpg";